export default __webpack_public_path__ + "static/media/img (3).2850f4e4.jpg";